const languages = [
    {code: `en`, name: 'english', shortName: 'eng'},
    {code: `es`, name: 'spanish', shortName: 'spa'},
    {code: `it`, name: 'italian', shortName: 'ita'},
    {code: `de`, name: 'german', shortName: 'ger'},
    {code: `nl`, name: 'dutch', shortName: 'dut'},
    // {code: `el`, name: 'greek', shortName: 'ell'},
    // {code: `hr`, name: 'croatian', shortName: 'hrv'},
    {code: `fr`, name: 'french', shortName: 'fra'},
    {code: `pt`, name: 'portuguese', shortName: 'por'},
    {code: `ro`, name: 'romanian', shortName: 'ron'},
    // {code: `ru`, name: 'russian', shortName: 'rus'},
    // {code: `zh`, name: 'chinese', shortName: 'chi'},
    // {code: `jp`, name: 'japanese', shortName: 'jap'},
    // {code: `ko`, name: 'korean', shortName: 'kor'},
    // {code: `ar`, name: 'arabic', shortName: 'ara'},
    // {code: `cs`, name: 'czech', shortName: 'cze'},
    // {code: `sk`, name: 'slovak', shortName: 'slo'},
    {code: `pl`, name: 'polish', shortName: 'pol'},
    {code: `hu`, name: 'hungarian', shortName: 'hun'},
    // {code: `he`, name: 'hebrew', shortName: 'heb'},
    // {code: `hi`, name: 'hindi', shortName: 'hin'},
    {code: `fi`, name: 'finnish', shortName: 'fin'},
    {code: `sv`, name: 'swedish', shortName: 'swe'},
    {code: `nn`, name: 'norwegian nynorsk', shortName: 'nno'},
    {code: `da`, name: 'danish', shortName: 'dan'},
];
module.exports = {
    languages: languages.map(item => item.code),
    allLanguages: languages,
    defaultLanguage: 'en'
};
